const tipoAgrupamentoList = [
  {
    value: 1,
    label: "Capital",
    text: "Capital",
  },
  {
    value: 2,
    label: "Interior",
    text: "Interior",
  },
  {
    value: 3,
    label: "Por Município",
    text: "Por Município",
  },
];

export { tipoAgrupamentoList };
